import { render, staticRenderFns } from "./AcquisitionCTA.vue?vue&type=template&id=665fdc2b&scoped=true&"
import script from "./AcquisitionCTA.vue?vue&type=script&lang=ts&"
export * from "./AcquisitionCTA.vue?vue&type=script&lang=ts&"
import style0 from "./AcquisitionCTA.vue?vue&type=style&index=0&id=665fdc2b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665fdc2b",
  null
  
)

export default component.exports